import {parametroGetDuck, parametrosGetDuck, parametroEditDuck} from './duck';

const parametrosReducers = {
  parametroGet: parametroGetDuck.reducer,
  parametrosGet: parametrosGetDuck.reducer,
  parametroEdit: parametroEditDuck.reducer,
};

export {parametrosReducers};
